import React from 'react'
import BlogCard from './BlogCard'


const Blog = ({heading, BlogData, width="lg:w-[850px]"}) => {
  return (
    <div className={`w-[100%] mx-auto md:w-[80%] ${width}`}>
      <h1 className="text-[25px] md:text-[40px] text-center font-bold mb-14 mx-auto">{heading}</h1>
      {
         BlogData.map((blog)=>{
            return(
               <BlogCard key={blog.id} question={blog.question} answer={blog.answer} />
            )
         })
      }
    </div>
  )
}

export default Blog
